import storeEngine from 'store/src/store-engine';
import sessionStorage from 'store/storages/sessionStorage';
import cookieStorage from 'store/storages/cookieStorage';
import Store from 'store';
import expire from 'store/plugins/expire';
import defaults from 'store/plugins/defaults';

const StoreMock: StoreJsAPI = {
    get(_: string, defaultValue = '') {
        return defaultValue;
    },
    set() {
        return;
    },
    version: '',
    enabled: false,
    remove() {},
    each() {},
    clearAll() {},
    hasNamespace() {
        return false;
    },
    createStore() {
        return this;
    },
    addPlugin() {},
    namespace() {
        return this;
    },
};

export const sessionStore = __NODEJS__ ? StoreMock : storeEngine.createStore([sessionStorage]);

export const cookieStore = storeEngine.createStore([cookieStorage], [expire, defaults]);

export const localStore = __NODEJS__ ? StoreMock : Store;
